module.exports = __webpack_public_path__ + "img/filter.63f5d6e0.svg";